import * as dotProp from 'dot-prop-immutable';

import { createReducer } from '@topconagriculture/frontend-utils';

import { boostrapApp } from './bootstrap.actions';

export type BoostrapState = {
  appInitialized: boolean;
  error: Error | null;
};

export const initialState: BoostrapState = {
  appInitialized: false,
  error: null,
};

const bootstrapReducer = createReducer(initialState, {
  [boostrapApp.done.type]: (state: BoostrapState) => dotProp.set(state, 'appInitialized', true),
  [boostrapApp.failed.type]: (state: BoostrapState, { error }: ReturnType<typeof boostrapApp.failed>) =>
    dotProp.set(state, 'error', error),
});

export default bootstrapReducer;
